import { memo, useEffect, useState } from 'react'

import { useAuth, useDashboard } from '@presentation/hooks'
import {
  SidebarMenuProps,
  SidebarSubmenuProps
} from '@presentation/types/shared'

import {
  SidebarNavigationMenu,
  SidebarNavigationMenuDropdown
} from './menu/sidebar-navigation-menu'
import * as S from './sidebar-navigation.styles'

const SidebarNavigation: React.FC = () => {
  const { canAccessRoute, hasExplicitPermission } = useAuth()
  const { isOpenSidebar, sidebar } = useDashboard()
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null)

  const onOpenDropdown = (index: number) => setActiveDropdown(index)
  const onCloseDropdown = () => setActiveDropdown(null)
  const canViewSubmenu = (submenu: SidebarSubmenuProps) => {
    return submenu.route.permission
      ? hasExplicitPermission(submenu.route.permission)
      : canAccessRoute(submenu.route.path)
  }

  const canViewMenu = (menu: SidebarMenuProps) => {
    if (menu.items) {
      return menu.items.some(canViewSubmenu)
    }

    if (menu.route) {
      return canAccessRoute(menu.route.path)
    }

    return false
  }

  // Fecha o dropdown ativo quando houver mudança de aberto/fechado no sidebar
  useEffect(() => {
    setActiveDropdown(null)
  }, [!isOpenSidebar])

  return (
    <S.Container>
      <S.MenuWrapper>
        {sidebar.menus.map((menu, index) => {
          const commonProps = {
            menu: menu,
            key: index
          }

          return (
            <>
              {canViewMenu(menu) ? (
                menu.items ? (
                  <SidebarNavigationMenuDropdown
                    isOpen={activeDropdown === index}
                    onOpen={() => onOpenDropdown(index)}
                    onClose={() => onCloseDropdown()}
                    {...commonProps}
                  />
                ) : (
                  <SidebarNavigationMenu {...commonProps} />
                )
              ) : null}
            </>
          )
        })}
      </S.MenuWrapper>
    </S.Container>
  )
}

export default memo(SidebarNavigation)
